// Utility functions for handling URLs in different environments
export const getImageUrl = (filename, type = 'listings') => {
  if (!filename) return null;
  
  const baseUrl = process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001');
  
  // If filename already includes the subdirectory, use as is
  if (filename.includes('/')) {
    return `${baseUrl}/uploads/${filename}`;
  }
  
  // Otherwise, add the appropriate subdirectory
  return `${baseUrl}/uploads/${type}/${filename}`;
};

// Get base server URL (API server)
export const getServerUrl = () => {
  return process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001');
};

// Get API base URL
export const getApiUrl = () => {
  return process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001');
};

export default getImageUrl;